module.exports = __webpack_public_path__ + "img/MLN.0b6aa30d.svg";